Vue.component('create-quiz', {
    data () {
        return {
            createForm: $.extend(true, new Form({
                data: {
                    name: ''
                }
            }), {}),
        };
    },

    methods: {
        submit () {
            Http.post('/api/questions/create', this.createForm).then((response) => {
                this.createForm.resetForm();

                $('#create-quiz').modal('hide');

                $('#create-quiz').on('hidden.bs.modal', () => {
                    window.location = "/admin/questions/edit/" + response.id;
                });
            });
        }
    }
});